import { Grid } from "@mui/material";
import React from "react";
import { icons } from "../../../../constants";

const FilterSection = () => {
  return (
    <Grid
      container
      style={{ marginTop: 20, marginBottom: 10 }}
      alignItems={"center"}
    >
      {/* Empty filter section to maintain consistent spacing with other pages */}
      <div style={{ height: 35, marginLeft: 16 }}>
        {/* This empty div maintains the same height as the filter icon in other pages */}
      </div>
    </Grid>
  );
};

export default FilterSection;
